import React from "react";
import Layout1 from "../../components/layout1";
import "./index.css";
import { Card } from "antd";
import { useNavigate, Link } from "react-router-dom";
import { useCan } from "../../utils/permissions";
const { Meta } = Card;

const Dashboard = () => {
  const navigate = useNavigate();
  const can = useCan();
  const canReadUser = can("user", "read");
  const canCreateUserUser = can("user", "create");
  const canUpdateUser = can("user", "update");
  const canDeleteUser = can("user", "delete");

  const canReadRole = can("role", "read");
  const canCreateRole = can("role", "create");
  const canUpdateRole = can("role", "update");
  const canDeleteRole = can("role", "delete");

  const canReadSurvey = can("surveyTemplate", "read");
  const canCreateSurvey = can("surveyTemplate", "create");
  const canUpdateSurvey = can("surveyTemplate", "update");
  const canDeleteSurvey = can("surveyTemplate", "delete");

  const canReadAppointment = can("appointment", "read");
  const canReadWorkOrder = can("workOrders", "read");
  const disablePointerEvents = (hasPermission) => {
    return !hasPermission ? { pointerEvents: 'none', opacity: 0.5 } : {};
  };
  return (
    <Layout1>
      <div className="dashboardcls">
        <div className="mb-4">
          <div className="content">Dashboard</div>
          <div className="d-flex justify-content-evenly">
            {canReadWorkOrder &&

              <div className="mt-4">
                <Link to="/work-order" style={{ textDecoration: "none", ...disablePointerEvents(canReadWorkOrder) }}>
                  <Card hoverable style={{ width: "28vw", height: "36vh" }}>
                    <Meta
                      title="Work Orders"
                      description="Search by work order."
                    />
                  </Card>
                </Link>
              </div>
            }
            {canReadAppointment &&
              <div className="mt-4">
                <Link to="/appointments" style={{ textDecoration: "none", ...disablePointerEvents(canReadAppointment) }} >
                  <Card hoverable style={{ width: "28vw", height: "36vh" }}>
                    <Meta
                      title="Appointments"
                      description="View a calendar of all upcoming appointment dates."
                    />
                  </Card>
                </Link>
              </div>
            }
          </div>
          <div className="d-flex justify-content-evenly">
            {canReadSurvey && canCreateSurvey && canUpdateSurvey && canDeleteSurvey &&
              <div className="mt-4">
                <Link to="/survey-results" style={{ textDecoration: "none", ...disablePointerEvents(canReadSurvey) }}>
                  <Card hoverable style={{ width: "28vw", height: "36vh" }}>
                    <Meta
                      title="Survey Results"
                      description="View a list of all individual survey results for all orders."
                    />
                  </Card>
                </Link>
              </div>
            }
            {canReadUser && canCreateUserUser && canUpdateUser && canDeleteUser &&
              <div className="mt-4">
                <Link to="/technicians" style={{ textDecoration: "none", ...disablePointerEvents(canReadUser) }}>
                  <Card hoverable style={{ width: "28vw", height: "36vh" }}>
                    <Meta
                      title="Technicians"
                      description="View all technicians in one spot. See their details and open orders."
                    />
                  </Card>
                </Link>
              </div>
            }
          </div>
          <div className="d-flex justify-content-evenly">
            {canReadRole && canCreateRole && canUpdateRole && canDeleteRole &&
              <div className="mt-4">
                <Link to="/role" style={{ textDecoration: "none", ...disablePointerEvents(canReadRole) }}>
                  <Card hoverable style={{ width: "28vw", height: "36vh" }}>
                    <Meta
                      title="Role"
                      description="Admins can manage all roles, assign them to users, and control permissions in one place."
                    />
                  </Card>
                </Link>
              </div>
            }
            {canReadUser && canCreateUserUser && canUpdateUser && canDeleteUser &&

              <div className="mt-4">
                <Link to="/user" style={{ textDecoration: "none", ...disablePointerEvents(canReadUser) }}>
                  <Card hoverable style={{ width: "28vw", height: "36vh" }}>
                    <Meta
                      title="User"
                      description="Users can be added, updated, and removed, with the ability to assign specific roles and permissions for customized access."
                    />
                  </Card>
                </Link>
              </div>
            }
          </div>
        </div>
      </div>
    </Layout1>
  );
};

export default Dashboard;
